import { all } from "redux-saga/effects";
import { menuSaga } from "./menuSaga";
import { actions } from "./menuSlice";
export { menuReducer } from "./menuSlice";
export const { fetchMenuStart, fetchMenuSuccess, fetchMenuFailure, resetMenu } = actions;

export function* menuSagas() {
  yield all([menuSaga()]);
}
